module.exports = __webpack_public_path__ + "img/img-2-min.d18a6369.webp";